import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { CurrentSiteService } from '../../services/current-site.service';
import { DataCollection } from '../../models/site-content/data-collection.model';
import { Folder } from '../../models/site-content/folder.model';
import { FolderFormInstanceTree } from '../../models/folder-form-instance-tree.model';

@Component({
    selector: 'app-select-folder',
    templateUrl: './select-folder.dialog.html',
    styleUrls: ['./select-folder.dialog.scss'],
    standalone: false
})
export class SelectFolderDialog implements OnInit {
    // Properties.
    private treePath: string; // Two-way finding with the tree control.
    private selectedFolderPath: string = null;
    private iSelectedFolderId: number = 0;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<SelectFolderDialog>,
        private currentSiteService: CurrentSiteService)
    {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        this.treePath = "/";

        return;
    }

    // Methods called by my HTML.
    public get Site(): DataCollection {
        return (this.currentSiteService.Site);
    }

    public get TreePath(): string {
        return (this.treePath);
    }
    public set TreePath(pathParam: string) {
        this.treePath = pathParam;
    }

    public get SelectedFolderPath(): string {
        return (this.selectedFolderPath);
    }

    // Handle control events.
    public onNodeSelected(eventData: any): void {
        // Examine the selected item.
        let item: any = eventData.item;
        let itemType: string = item.getType();
        let tree: FolderFormInstanceTree = eventData.tree;

        if ((itemType != null) && (itemType.toLowerCase() == Folder.TypeName)) {
            // Find the selected folder in the current site.
            let currentSite: DataCollection = this.currentSiteService.Site;

            if (currentSite != null) {
                //let rootFolder: Folder = currentSite.getRootFolder();
                this.selectedFolderPath = tree.deriveFolderPath(tree, item.id);
                this.iSelectedFolderId = item.id;
            } // if
        } // if

        return;
    }

    public selectPathClicked(): void {
        let resultFolder: Folder = new Folder();
        resultFolder.id = this.iSelectedFolderId;
        resultFolder.name = this.selectedFolderPath;

        this.dialogRef.close(resultFolder);
    }
}
